// global
import React, { Component } from 'react';
import { Popup, Image, Grid, Icon } from 'semantic-ui-react';
// local
// css
import './DeviceLabel.scss';
// images
import ic_flow_alert_gray from 'app/_assets/img/ic_flow_alert_gray.png';
import ic_concentrator from 'app/_assets/img/ic_concentrator.svg';
import ic_atas_device from 'app/_assets/img/ic_atas_device.svg';

const Content = () => {
    return (
        <Grid columns={2}>
            <Grid.Row>
                <Grid.Column id="level">
                    <div className="column-title">TIPOS DE DISPOSITIVO</div>
                    <div className="pressure-row">
                        <Image src={ic_atas_device} />
                        <span className="label-text"> ATAS Adulto </span>
                    </div>
                    <div className="pressure-row">
                        <Image src={ic_concentrator} />
                        <span className="label-text"> ATAS Concentrador </span>
                    </div>
                </Grid.Column>

                <Grid.Column id="level">
                    <div className="column-title">ESTADOS DA BATERIA</div>
                    <div className="pressure-row">
                        <Icon name="battery three quarters" size="big" color="green" />
                        <span className="label-text"> Bateria normal. </span>
                    </div>
                    <div className="pressure-row">
                        <Icon name="battery quarter" size="big" color="yellow" />
                        <span className="label-text"> Bateria baixa. </span>
                    </div>
                    <div className="pressure-row">
                        <Icon name="battery low" size="big" color="red" />
                        <span className="label-text"> Bateria muito baixa. </span>
                    </div>
                    <div className="pressure-row">
                        <Icon name="battery zero" size="big" color="red" />
                        <span className="label-text"> Bateria em estado crítico, realizar troca com urgência. </span>
                    </div>
                </Grid.Column>

                <Grid.Column id="level">
                    <div className="column-title">ESTADOS DA CONECTIVIDADE</div>
                    <div className="pressure-row">
                        <Icon name="wifi" size="big" color="green" />
                        <span className="label-text"> Dispositivo enviou mensagem nas últimas 2 horas. </span>
                    </div>
                    <div className="pressure-row">
                        <Icon name="wifi" size="big" color="yellow" />
                        <span className="label-text"> Dispositivo com conectividade baixa: não enviou mensagem nas últimas 2 horas. </span>
                    </div>
                    <div className="pressure-row">
                        <Icon name="wifi" size="big" color="red" />
                        <span className="label-text"> Dispositivo offline: não enviou mensagem nas últimas 4 horas. </span>
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

class DeviceLabel extends Component {
    render() {
        return (
            <Popup id="popup-cylinder-legend" trigger={<Image id="popup-cylinder-legend-trigger" src={ic_flow_alert_gray} />} content={<Content />} flowing />
        );
    }
}

export default DeviceLabel;
